import { previewSidebar } from '@/translations/pl/editor/previewSidebar'
import { sizing } from '@/translations/pl/editor/sizing'
import { tabs } from '@/translations/pl/editor/tabs'

export const editor = {
  title: 'Edytor',
  models: 'Modele',
  name: 'Nazwa',
  dragHover: 'Przeciągnij aby zmienić wartość',
  position: 'Pozycja',
  rotation: 'Rotacja',
  scale: 'Skala',
  size: 'Rozmiar',
  addModels: 'Dodaj modele',
  noModelsLoaded: 'Brak załadowanych modeli',
  noModelsLoadedDescription: 'Dodaj je w zakładce modele',
  goBackToStep: 'Powrót do edycji konfiguracji',
  downComplete: 'Pobrano pomyślnie',
  loadComplete: 'Model załadowano pomyślnie',
  addModel: 'Załaduj model do edytora',
  fileAddedPara1: 'Twoj plik został dodany i jest gotowy',
  fileAddedPara2: 'Czy chcesz go załadować do widoku?',
  fileNotFound:
    'Wystąpił problem ze znaleźieniem pliku, spróbuj ponownie bądź wybierz z listy',
  fileCannotBeLoaded: 'Wystąpił problem z zaladowaniem pliku',
  resetCamera: 'Resetuj kamerę',
  toggleRotation: 'Obracanie kamery',
  toggleFullscreen: 'Tryb pełnoekranowy',
  changeSceneWidth: 'Zmień szerokość sceny',
  sceneWidthTitle: 'Szerokość sceny',
  applySceneWidth: 'Zastosuj szerokość',
  resetSceneWidth: 'Przywróć domyślną szerokość',
  floorGrid: 'Podłoga z siatką',
  focusElement: 'Skupienie na modelu',
  modifiedNode: 'Model ma niezapisane zmiany',
  showModel: 'Odkryj model (podglądowo - nie zmienia szablonu konfiguracji)',
  hideModel: 'Ukryj model (podglądowo - nie zmienia szablonu konfiguracji)',
  toggleTransform: 'Przełącz kontrolki transformacji (Shift + E)',
  deleteModel: 'Usuń model i jego zmiany',
  deleteModelTitle: 'Czy jesteś pewien?',
  deleteModelWarning:
    'Usunięcie tego spowoduje również usunięcie pól z listy zmian. Czy napewno chcesz usunąć ten model?',
  press: 'Kliknij',
  toSetNormal: 'aby przesuwać w przestrzeni',
  toSetRotate: 'aby edytować obrotem',
  toSetScale: 'aby edytować skalę',
  modelsDimensions: 'Wymiary modeli',
  length: 'Długość',
  height: 'Wysokość',
  width: 'Szerokość',
  code: 'Kod',
  loading: 'Ładowanie edytora...',
  tabs: tabs,
  sizing: sizing,
  previewSidebar: previewSidebar,
  uploadModel: 'Prześlij model',
  detectedErrors: 'Wykryto {count} błędów',
  nextError: 'Następny błąd',
  prevError: 'Poprzedni błąd',
  revalidate: 'Sprawdź błędy',
  groups: {
    node: 'Grupy węzła',
    select: 'Wybierz grupę',
    savedCorrectly: 'Grupy zostały zapisana pomyślnie',
    added: 'Grupa została dodana  pomyślnie',
    deleteConfirm: 'Czy napewno chcesz usunąć tą grupę?',
    deletePara: 'Tej operacji nie można cofnąć',
    modelAlsoBelongs: 'Ten model także należy do grup',
    modelAlsoNotBelongs: 'Ten model nie należy do innych grup',
    assignedToOtherGroups: 'Ten model jest przypisany w innych grupach',
    otherGroups: 'Inne grupy',
    noneSelected: 'Brak wybranej grupy',
    save: 'Zapisz grupy',
  },
  errors: {
    notFoundSavingModel:
      'Nie znaleziono modelu w liście. Proszę użyć "Zapisz jako nowy"',
    dimensionMustBePositive: 'Wymiary muszą być wartościami dodatnimi',
    notFoundLoadingModel: 'Nie znaleziono modelu.',
  },
  success: {
    saved: 'Poprawnie zapisano model',
    changedVisibility: 'Zapisano zmiany w widoczności modeli',
    changesReverted: 'Przywrócono zmiany modelu',
  },
  validation: {
    fixErrors:
      'Popraw błędy przed zapisaniem. Węzły z błędami są oznaczone na czerwono.',
    codeRequired: 'Kod jest wymagany',
    lengthPositive: 'Długość musi być wartością dodatnią',
    heightPositive: 'Wysokość musi być wartością dodatnią',
    widthPositive: 'Szerokość musi być wartością dodatnią',
    nameRequired: 'Nazwa jest wymagana',
  },
  chooseBackground: 'Wybierz tło',
  chooseBackgroundN: 'Wybierz tło {n}',
  chooseScenery: 'Wybierz scenerię',
  chooseSceneryN: 'Wybierz scenerię {n}',
  withGrid: 'Z gridem',
  withoutGrid: 'Bez gridu',
  dependencies: {
    noDependenciesGlobal: 'Brak zależności dla tej konfiguracji',
    noDependenciesGlobalDescription: 'Dodaj je w widoku konfiguracji',
    noDependencies: 'Brak zależności dla tego węzła',
    title: 'Zależności modelu',
    rules: 'Reguły',
    options: 'Opcje',
    groups: 'Grupy',
    models: 'Modele',
    dependenciesFor: 'Zależności dla ',
    hasDependencies: 'Ten węzeł ma zależności',
    noDependenciesIcon: 'Ten węzeł nie ma zależności',
    expandAll: 'Rozwiń wszystkie',
    collapseAll: 'Zwiń wszystkie',
  },
  properties: {
    elementVisible: 'Element jest domyślnie widoczny',
    elementNotVisible: 'Element jest domyślnie ukryty',
  },
  lights: {
    title: 'Światła',
    label: 'Etykieta',
    code: 'Kod',
    type: 'Typ',
    disabled: 'Wyłączone',
    enabled: 'Włączone',
    intensity: 'Intensywność',
    color: 'Kolor',
    angle: 'Kąt',
    x: 'X',
    y: 'Y',
    z: 'Z',
    global: 'Globalne',
    updated: 'Zaktualizowano',
    copy: 'Kopiuj',
    castsShadow: 'Rzuca cień',
    edit: 'Edytuj',
    save: 'Zapisz',
    cancel: 'Anuluj',
    delete: 'Usuń',
    all: 'Wszystkie',
    newLight: 'Nowe światło',
    deleteConfirmTitle: 'Usunąć światło?',
    deleteConfirmGlobal:
      'To światło zostanie usunięte ze wszystkich konfiguracji. Czy na pewno chcesz kontynuować?',
    deleteConfirmDescription: 'Tej operacji nie można cofnąć.',
    addLight: 'Dodaj światło',
    chooseNewLightType: 'Wybierz typ nowego światła',
    chooseLightScope: 'Wybierz zakres światła',
    lightType: {
      ambient: 'Otoczenia',
      directional: 'Kierunkowe',
    },
    scope: {
      global: 'Globalne',
      local: 'Lokalne',
    },
    noLights: 'Nie dodano jeszcze żadnych świateł',
    assign: 'Przypisz',
    unlinkAssign: 'Odłącz przypisanie',
    assigned: 'Przypisane',
    globalSaveWarning:
      'To światło jest globalne. Zmiany będą miały wpływ na wszystkie konfiguracje, które z niego korzystają.',
    confirmGlobalSave: 'Zapisz mimo to',
    cancelGlobalSave: 'Anuluj',
    savedSuccess: 'Światło zapisane pomyślnie',
    updatedSuccess: 'Światło zaktualizowane pomyślnie',
    assignedSuccess: 'Światło przypisane pomyślnie',
    unassignedSuccess: 'Przypisanie światła usunięte pomyślnie',
  },
}
